/**
 * Universal subscribe and unsubscribe button
 *
 * @see EdSpireSubscriptions::subscribe_to_post_button()
 *
 */
e.S.button = {
	api : config.api + 'subscriptions/',

	init : function(){
		_.bindAll( this, 'subscribe', 'un_subscribe' );

		e.el.body.on( 'click', '.edspire-subscribe', function(){
			e.S.button.subscribe( $(this) );
		});

		e.el.body.on( 'click', '.edspire-un-subscribe', function(){
			e.S.button.un_subscribe( $(this) );
		});

		e.el.body.on( 'mouseover', '.edspire-un-subscribe', this._hover_un_sub );
		e.el.body.on( 'mouseleave', '.edspire-un-subscribe', this._leave_un_sub );

		//subscribe toggles
		var $subs = $( '.subscriptions' );
		$subs.on( 'click', 'input.subscription-status', this._handle_subscribe_toggle );

		//remove subscrption row (x)
		$subs.on( 'click', '.remove-subscription', this._remove_subscription_all_formats );
	},

	/**
	 * Handles the toggle checkboxes found on /subscriptions page
	 *
	 * @private
	 */
	_handle_subscribe_toggle : function(){
		var $input = $(this);
		var $data = {
			id : $input.data( 'id' ),
			type : $input.data( 'type' ),
			blog_id : $input.data( 'blog_id' ),
			format : $input.data( 'format' )
		};
		if( !$input.prop( "checked" ) ){
			$data.method = 'unsubscribe';
			$.post( e.S.button.api, $data );
			$input.prop( "checked", false );
		} else {
			$data.method = 'subscribe';
			$.post( e.S.button.api, $data );
			$input.prop( "checked", true );
		}
	},

	/**
	 * Remove all subscription formats for an item
	 *
	 * @private
	 */
	_remove_subscription_all_formats : function(){
		var $item = $( this );
		var data = {
			id : $item.data( 'id' ),
			blog_id : $item.data( 'blog_id' ),
			type    : $item.data( 'type' ),
			method : 'unsubscribe_all_formats'
		};
		$item.parents( 'tr' ).remove();

		$.post( e.S.button.api, data );

	},


	_hover_un_sub : function(){
	    var $el = $(this);
		$el.addClass( 'subscribe-hover' );
		$el.text( $el.data( 'mouseover' ) );
	},

	_leave_un_sub : function(){
		var $el = $(this);
		$el.removeClass( 'subscribe-hover' );
		$el.text( $el.data( 'mouseout' ) );
	},

	subscribe : function( el ){
		var data = {
			id : el.data( 'id' ),
			type : el.data( 'type' ),
			blog_id : el.data( 'blog_id' ),
			method : 'subscribe_all_formats'
		};
		$.post( e.S.button.api, data );

		el.parent().find( '.edspire-un-subscribe' ).show();
		el.parent().find( '.edspire-subscribe' ).hide();
		el.parent().find( '.manage' ).show();
	},


	un_subscribe : function( el ){
		var data = {
			id : el.data( 'id' ),
			type : el.data( 'type' ),
			blog_id : el.data( 'blog_id' ),
			method : 'unsubscribe_all_formats'
		};
		$.post( e.S.button.api, data );

		el.parent().find( '.edspire-un-subscribe' ).hide();
		el.parent().find( '.edspire-subscribe' ).show();
		el.parent().find( '.manage' ).hide();
	}
};